import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Select, Form } from 'antd';

import FloatingLabel from '../FloatingLabel/FloatingLabel';
import { CheckCircle, ChevronDown, ChevronUp } from '../../assets/icons';

const SelectDropdown = ({ initialValue, options, label, name, inputId, id, onChangeSelect, rules, classVal, floatClassVal, alwaysSmall }) => {
  const [typeOpen, setTypeOpen] = useState(false);

  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    initialValue && setSelectedValue(initialValue);
  }, [initialValue]);

  return (
    <FloatingLabel
      label={label}
      inputId={inputId}
      inputValue={selectedValue}
      className={`${floatClassVal ? floatClassVal : 'w-100'}`}
      alwaysSmall={alwaysSmall}
    >
      <Form.Item className='mb-24' name={name} rules={rules}>
        <Select
          defaultValue={initialValue}
          id={id}
          className={classVal}
          popupClassName='filter-select-dropdown'
          onChange={(value) => {
            setSelectedValue(value);
            onChangeSelect(name, value);
          }}
          getPopupContainer={(trigger) => trigger.parentNode}
          value={selectedValue}
          onDropdownVisibleChange={() => setTypeOpen(!typeOpen)}
          suffixIcon={typeOpen ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
          menuItemSelectedIcon={<CheckCircle verticalAlign='-8px' color='#8A4743' />}
        >
          {options?.map((option) => (
            <Select.Option key={option} value={option}>
              {option}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </FloatingLabel>
  );
};

SelectDropdown.propTypes = {
  initialValue: PropTypes.string,
  options: PropTypes.array,
  label: PropTypes.string,
  name: PropTypes.string,
  inputId: PropTypes.string,
  id: PropTypes.string,
  onChangeSelect: PropTypes.func,
  rules: PropTypes.array,
  classVal: PropTypes.string,
  alwaysSmall: PropTypes.bool,
};

SelectDropdown.defaultProps = {
  initialValue: '',
  options: [],
  label: '',
  name: '',
  inputId: '',
  id: '',
  onChangeSelect: () => {},
  rules: [],
  classVal: '',
  alwaysSmall: false,
};

export default SelectDropdown;
